// File: webelieve-frontend/src/features/intake/api/intakeInboxApi.ts
// EF-7F: API client for lead inbox

import { apiClient } from '@/config/api';

export interface InboxItem {
  id: string;
  type: 'form_submission' | 'email' | 'phone' | 'referral' | 'walk_in' | 'other';
  source_badge: string;
  client_id?: string;
  client_name?: string;
  email?: string;
  phone?: string;
  practice_area?: string;
  summary: string;
  is_read: boolean;
  priority: 'high' | 'medium' | 'low';
  assigned_to_user_id?: string;
  created_at: string;
  metadata?: Record<string, any>;
}

export interface InboxFilters {
  source?: string;
  practice_area?: string;
  is_read?: boolean;
  assigned_to?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface InboxResult {
  items: InboxItem[];
  total: number;
  unread_count: number;
  page: number;
  limit: number;
}

export interface InboxStats {
  total: number;
  unread: number;
  by_source: Record<string, number>;
  by_practice_area: Record<string, number>;
}

const BASE = '/api/v1/intake';

export const intakeInboxApi = {
  getInbox: async (filters: InboxFilters = {}): Promise<InboxResult> => {
    const params: Record<string, any> = {};
    if (filters.source) params.source = filters.source;
    if (filters.practice_area) params.practice_area = filters.practice_area;
    if (filters.is_read !== undefined) params.is_read = String(filters.is_read);
    if (filters.assigned_to) params.assigned_to = filters.assigned_to;
    if (filters.search) params.search = filters.search;
    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;

    const res = await apiClient.get<{ data: InboxResult }>(`${BASE}/inbox`, params);
    if (!(res as any).success) throw new Error((res as any).error || 'Failed to fetch inbox');
    return (res as any).data;
  },

  getStats: async (): Promise<InboxStats> => {
    const res = await apiClient.get<{ data: InboxStats }>(`${BASE}/inbox/stats`);
    if (!(res as any).success) throw new Error((res as any).error || 'Failed to fetch inbox stats');
    return (res as any).data;
  },

  markAsRead: async (clientId: string): Promise<void> => {
    const res = await apiClient.post<void>(`${BASE}/inbox/${clientId}/read`);
    if (!(res as any).success) throw new Error((res as any).error || 'Failed to mark as read');
  },
};
